import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { useSelector, useDispatch } from 'react-redux';

import { MeetingForm } from 'common/forms';
import { MeetingFormValues } from 'common/models/Forms';

import { PageControls, QuestionTitle } from '../../../../components';
import { selectAgreementMeeting, setAgreementMeetingAction } from '../../../../ducks';
import { I18nNameSpaces } from '../../../../../../common/services/i18n';
import { useFormStepContinueRef } from '../../../../hooks/useFormStepContinueRef';
import { FeatureProps } from '../../../../index';

export default function AgreementMeetingFeature({ isPrivileged }: FeatureProps) {
  const { t } = useTranslation(I18nNameSpaces.Forms);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectAgreementMeeting);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } = useFormStepContinueRef<MeetingFormValues>();

  function handleBackClick() {
    navigate(`/form/${id}/protocol/consultant-confirmation`);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function bindSubmit(formik: FormikProps<MeetingFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: MeetingFormValues) {
    if (!isPrivileged) {
      dispatch(setAgreementMeetingAction(values));
    }
    navigate(`/form/${id}/agreement/summary`);
  }

  return (
    <>
      <QuestionTitle>{t('meetingForm.title')}</QuestionTitle>
      <MeetingForm initialValues={initialValues || undefined} onSubmit={handleSubmit} bindSubmit={bindSubmit} />
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
